import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";
import { Overview } from "../../../components/dashboard/Overview";

// Re-adding the styles I mistakenly removed.
export const MainContainer = styled.div`
  /* ... original style ... */
`;
export const WelcomeMessage = styled.div`
  /* ... original style ... */
`;
export const UserInfo = styled.p`
  /* ... original style ... */
`;
export const Section = styled.div`
  margin-top: 40px;
`;
export const RecentActivity = styled.div`
  /* ... original style ... */
`;
export const ActivityItem = styled.div`
  /* ... original style ... */
`;

export const ProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  border: 1px solid #dee2e6;
`;

export const TableHead = styled.thead`
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #dee2e6;
  }
`;

export const TableHeader = styled.th`
  padding: 12px 16px;
  text-align: left;
  color: #5a5a5a;
  font-size: 14px;
  font-weight: 500;
`;

export const TableCell = styled.td`
  padding: 12px 16px;
  color: #212529;
  font-size: 14px;
  font-weight: 400;
`;

export const TableButton = styled.button`
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #0085ff;
  background: white;
  color: #0085ff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #0085ff;
    color: white;
  }
`;

export const UsageBox = styled.div`
  width: 100%;
  height: 135px;
  padding: 11px 15px;
  margin-bottom: 20px;
  border-radius: 12px;
  border: 1px #dee2e6 solid;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const UsageText = styled.div`
  color: #5a5a5a;
  font-size: 12px;
  font-weight: 400;
`;

export const TitleContainer = styled.div`
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
`;

export const MoreButton = styled.button`
  color: #5a5a5a;
  font-size: 13px;
  font-weight: 500;
  padding: 0;
  cursor: pointer;
  border: none;
  background: none;
`;

export const ComponentsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const RecentFilesContainer = styled.div`
  display: flex;
  gap: 32px;
`;

export const RecentFileCard = styled.div`
  width: 337px;
  height: 286px;
  padding: 32px;
  background: white;
  border-radius: 8px;
  border: 1px #dee2e6 solid;
  display: inline-flex;
  flex-direction: column;
`;

export const ThumbnailImage = styled.img`
  width: 271px;
  height: 153px;
  margin-bottom: 16px;
`;

export const FileTitle = styled.p`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileDate = styled.p`
  color: #5a5a5a;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IntroContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 46px;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 20px;
`;

export const IntroTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  position: relative;
`;

export const SubText = styled.div`
  ${getTypography("korean", "body1")};
  color: ${designTokens.colors.font.tertiary};
`;

export const QuickSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const QuickBox = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;
  
  /* 화면 크기별 레이아웃 조정 */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    gap: 12px;
  }
  
  @media (min-width: 1025px) {
    gap: 20px;
  }
`;

// styles.ts
export const QuickButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 36px;
  gap: 16px;
  border-radius: 14px;
  border: 1px solid rgba(92, 110, 255, 0.1);
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(92, 110, 255, 0.08);
  cursor: pointer;
  transition: all 0.25s ease;
  overflow: hidden; /* 👈 오버레이 영역 제한 */
  flex: 1;
  min-width: 220px;

  &:hover {
    transform: translateY(-3px);
    border-color: rgba(92, 110, 255, 0.3);
    box-shadow: 0 8px 32px rgba(92, 110, 255, 0.18);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;
    box-shadow: 0 4px 20px rgba(92, 110, 255, 0.05);
  }
`;

export const HoverOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.9),
    rgba(245, 247, 255, 0.9)
  );
  color: #4b5eff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  opacity: 0;
  transition: opacity 0.35s ease, transform 0.3s ease;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  border-radius: 14px;
  padding: 20px;
  backdrop-filter: blur(8px);
  transform: translateY(10px);
  
  ${QuickButton}:hover & {
    opacity: 1;
    transform: translateY(0);
  }
`;



export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
  
  svg {
    width: 100%;
    height: 100%;
    color: #5c6eff;
    transition: color 0.3s ease;
  }

  ${QuickButton}:not(:disabled):hover & {
    transform: scale(1.08);
    svg {
      color: #4b5eff;
    }
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`;

export const ButtonText = styled.div`
  ${getTypography("korean", "body1")};
  font-weight: 500;
  color: #1a1a1a;
  text-align: center;
  letter-spacing: -0.2px;
  transition: color 0.2s ease;

  ${QuickButton}:not(:disabled):hover & {
    color: #4b5eff;
  }

  /* 화면 크기별 텍스트 크기 및 줄바꿈 조정 */
  @media (max-width: 480px) { 
    ${getTypography("korean", "body3")}
    white-space: normal;
    word-break: keep-all;
  } 

  @media (min-width: 481px) and (max-width: 768px) { 
    ${getTypography("korean", "body2")}
    white-space: nowrap; 
  } 

  @media (min-width: 769px) and (max-width: 1024px) {
    ${getTypography("korean", "body1")}
    white-space: nowrap;
  }

  @media (min-width: 1025px) {
    white-space: nowrap;
  }
`;

export const HistorySection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;
  width: 100%; /* Overview 컴포넌트와 동일하게 반응형으로 변경 */
  min-height: 246px; /* height를 min-height로 변경하여 내용에 따라 늘어날 수 있도록 */
`;